import { withProps } from 'recompose'

import { getButtonTappedEvent } from 'utils/analytics'

export type Fields = string | object | ((props: any) => object)

export default (fields: Fields) =>
  withProps(props => {
    let eventFields = {}

    if (typeof fields === 'function') {
      eventFields = fields(props)
    } else if (typeof fields === 'string') {
      eventFields = getButtonTappedEvent(fields)
    } else {
      eventFields = fields
    }

    return {
      fields: eventFields,
    }
  })
